module.exports = __webpack_public_path__ + "static/media/img_functions.87f44e86.png";